export default "__VITE_ASSET__DidmF9Sy__"